var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 27,
    viewBox: "0 0 26 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.8778 13.4994C16.8778 15.6444 15.1444 17.3778 12.9994 17.3778C10.8544 17.3778 9.12109 15.6444 9.12109 13.4994C9.12109 11.3544 10.8544 9.62109 12.9994 9.62109C15.1444 9.62109 16.8778 11.3544 16.8778 13.4994Z",
    stroke: "#444656",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9989 22.4585C16.823 22.4585 20.3872 20.2051 22.868 16.3051C23.843 14.7776 23.843 12.2101 22.868 10.6826C20.3872 6.78263 16.823 4.5293 12.9989 4.5293C9.17469 4.5293 5.61052 6.78263 3.12969 10.6826C2.15469 12.2101 2.15469 14.7776 3.12969 16.3051C5.61052 20.2051 9.17469 22.4585 12.9989 22.4585Z",
    stroke: "#444656",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.41739e06680de1a41cd5969bd2f6e29e.svg";
export { ForwardRef as ReactComponent };